import { ArrowRight, Check, CornerDownLeft } from 'lucide-react';
import { Link } from 'react-router';

import { PrimaryCTA } from '../../components/PrimaryCTA';
import { SecondaryCTA } from '../../components/SecondaryCTA';
import { SectionWrapper } from '../../components/SectionWrapper';
import { heroExchange } from './kaiCoachContent';
import { TranscriptSegments } from './KaiCoachTranscript';

import styles from './KaiCoachHeroSection.module.css';

export function KaiCoachHeroSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-hero-title"
      background="navy"
      className={styles.root}
      contentClassName={styles.content}
      data-testid="kai-coach-section-hero"
    >
      <div className={styles.copy}>
        <nav aria-label="Breadcrumb" className={styles.crumbs}>
          <ol>
            <li className={styles.crumb}>
              <Link to="/ai">KAI</Link>
            </li>
            <li aria-current="page" className={`${styles.crumb} ${styles.current}`}>
              Kai Coach
            </li>
          </ol>
        </nav>
        <h1 className={styles.title} id="kai-coach-hero-title">
          The AI coach that never writes the paper. <em>It asks the next question.</em>
        </h1>
        <p className={styles.lead}>
          Kai Coach is a Socratic coach built on your course’s own readings. When a student is
          stuck, it may supply a term, but never the reasoning. In its first course pilot, papers
          averaged twice as many developed arguments.
        </p>
        <div className={styles.actions}>
          <PrimaryCTA
            className={styles.primary}
            href="/contact"
            icon={<ArrowRight aria-hidden="true" size={16} />}
            label="Book a mapping call"
          />
          <SecondaryCTA className={styles.secondary} href="#session" label="See a full session" />
        </div>
        <p className={styles.note}>
          Built and tested at UCLA. Kudu builds every module at no cost to your institution.
        </p>
      </div>

      <figure className={styles.exchange}>
        <div className={styles.exchangeHead}>
          <span className={styles.coachName}>
            <span aria-hidden="true" className={styles.avatar}>
              K
            </span>
            Kai Coach
          </span>
          <span className={styles.exchangeTag}>Business Ethics · price controls</span>
        </div>
        <ol className={styles.turns}>
          {heroExchange.map((turn, index) => (
            <li className={turn.speaker === 'student' ? styles.studentTurn : styles.coachTurn} key={index}>
              <span className={styles.who}>{turn.speaker === 'coach' ? 'Kai Coach' : 'Student'}</span>
              <span className={styles.turnText}>
                <TranscriptSegments segments={turn.segments} />
              </span>
            </li>
          ))}
        </ol>
        <figcaption className={styles.chips}>
          <span className={styles.srOnly}>In this exchange, the coach:</span>
          <span className={styles.chipYes}>
            <Check aria-hidden="true" size={14} />
            Supplied the term
          </span>
          <span className={styles.chipNo}>
            <CornerDownLeft aria-hidden="true" size={14} />
            Left the reasoning to the student
          </span>
        </figcaption>
      </figure>
    </SectionWrapper>
  );
}
